/* -----------------------------------------------------------------------
   Amperage filter label consolidation.

   The amperage facet's underlying values are not tagged consistently --
   some products carry "20", others carry "20A" for the same US trade
   rating. That produces two separate checkboxes in Filter Results for the
   same amperage. normalizeAmpLabel groups values that mean the same thing;
   consolidateAmperageFilters merges their rows in the DOM while leaving
   both underlying checkboxes in the form so filtering keeps working.
   ----------------------------------------------------------------------- */
function normalizeAmpLabel(raw) {
  const stripped = String(raw == null ? "" : raw).replace(/\s+/g, "").toUpperCase();
  const hasTrailingA = stripped.slice(-1) === "A";
  const core = hasTrailingA ? stripped.slice(0, -1) : stripped;

  const isPlainNumber = /^[0-9]+(\.[0-9]+)?$/.test(core);
  const isNumericRange = /^[0-9]+(\.[0-9]+)?-[0-9]+(\.[0-9]+)?$/.test(core);
  const isTandem = /^[0-9]+(\.[0-9]+)?\/[0-9]+(\.[0-9]+)?$/.test(core);

  if (isPlainNumber || isNumericRange || isTandem) {
    return core + "A";
  }
  return stripped;
}

/* The search engine's collection rail and its results page already ship
   reviewed labels, so every label rewrite below leaves their text verbatim. */
function insideEngineRail(el) {
  return !!(el && typeof el.closest === "function" &&
    el.closest('collection-search-filters, #shopify-section-proxy-search'));
}

function brandKey(raw) {
  return String(raw == null ? "" : raw)
    .toLowerCase()
    .replace(/\s+/g, " ")
    .replace(/\s*\/\s*/g, "/")
    .trim();
}

var BRAND_GROUP_LABEL = {
  "square d": "Schneider / Square D",
  "schneider electric": "Schneider / Square D",
  "schneider/square d": "Schneider / Square D",
  "schneider electric/square d": "Schneider / Square D",
  "zinsco": "Zinsco",
  "zinsco/sylvania": "Zinsco",
  "eaton": "Eaton / Cutler-Hammer",
  "cutler-hammer": "Eaton / Cutler-Hammer",
  "cutler hammer": "Eaton / Cutler-Hammer",
  "eaton/cutler-hammer": "Eaton / Cutler-Hammer",
  "eaton/cutler hammer": "Eaton / Cutler-Hammer"
};

function normalizeBrandLabel(raw) {
  var key = brandKey(raw);
  if (BRAND_GROUP_LABEL[key]) return BRAND_GROUP_LABEL[key];
  return String(raw == null ? "" : raw).replace(/\s+/g, " ").trim();
}

function consolidateBrandFilters(container) {
  try {
    if (!container || typeof container.querySelectorAll !== "function") return;

    const lists = container.querySelectorAll(
      '.jsFilterUpdate[data-filter-id="brand"], .jsFilterUpdate[data-filter-id="brand_canonical"]'
    );
    lists.forEach((list) => {
      if (insideEngineRail(list)) return;

      const groups = new Map();

      list.querySelectorAll("li").forEach((li) => {
        const textEl = li.querySelector(".text");
        if (!textEl) return;
        const rawText = textEl.textContent || "";
        const key = normalizeBrandLabel(rawText);
        if (!key) return;
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push({ li, textEl, rawText });
      });

      groups.forEach((entries, key) => {
        let visible = entries.find((entry) => normalizeBrandLabel(entry.rawText) === key && entry.rawText.replace(/\s+/g, " ").trim() === key);
        if (!visible) visible = entries[0];
        visible.textEl.textContent = key;

        if (entries.length < 2 && BRAND_GROUP_LABEL[brandKey(entries[0].rawText)]) {
          visible.textEl.textContent = key;
        }

        if (entries.length < 2) return;

        const checkboxes = [];
        entries.forEach((entry) => {
          const checkbox = entry.li.querySelector('input[type="checkbox"]');
          if (checkbox) checkboxes.push(checkbox);

          if (entry.li !== visible.li) {
            entry.li.setAttribute("hidden", "");
            entry.li.classList.add("none");
            entry.li.setAttribute("data-brand-dup", "1");
          }
        });

        const anyChecked = checkboxes.some((cb) => cb.checked);
        if (anyChecked) {
          checkboxes.forEach((cb) => {
            cb.checked = true;
          });
        }

        checkboxes.forEach((cb) => {
          if (cb.getAttribute("data-brand-group-wired") === "1") return;
          cb.setAttribute("data-brand-group-wired", "1");
          cb.addEventListener("change", () => {
            const isChecked = cb.checked;
            checkboxes.forEach((other) => {
              if (other !== cb) other.checked = isChecked;
            });
          });
        });
      });
    });
  } catch (e) {
    /* consolidation must never block filtering */
  }
}

function consolidateAmperageFilters(container) {
  try {
    if (!container || typeof container.querySelectorAll !== "function") return;

    const lists = container.querySelectorAll('.jsFilterUpdate[data-filter-id="amperage"]');
    lists.forEach((list) => {
      if (insideEngineRail(list)) return;

      const groups = new Map();

      list.querySelectorAll("li").forEach((li) => {
        const textEl = li.querySelector(".text");
        if (!textEl) return;
        const rawText = textEl.textContent || "";
        const key = normalizeAmpLabel(rawText);
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push({ li, textEl, rawText });
      });

      groups.forEach((entries, key) => {
        // Prefer keeping visible whichever entry already read "...A" before
        // normalization; otherwise just keep the first one.
        let visible = entries.find((entry) => /A$/i.test(entry.rawText.trim()));
        if (!visible) visible = entries[0];
        visible.textEl.textContent = key;

        if (entries.length < 2) return;

        const checkboxes = [];
        entries.forEach((entry) => {
          const checkbox = entry.li.querySelector('input[type="checkbox"]');
          if (checkbox) checkboxes.push(checkbox);

          if (entry.li !== visible.li) {
            entry.li.setAttribute("hidden", "");
            entry.li.classList.add("none");
            entry.li.setAttribute("data-amp-dup", "1");
          }
        });

        // If any checkbox in the group is already checked, keep them synced.
        const anyChecked = checkboxes.some((cb) => cb.checked);
        if (anyChecked) {
          checkboxes.forEach((cb) => {
            cb.checked = true;
          });
        }

        // Keep every checkbox in the group in sync going forward. Guarded so
        // repeat calls (after every AJAX re-render, plus the boot path) never
        // attach a second listener to the same node.
        checkboxes.forEach((cb) => {
          if (cb.getAttribute("data-amp-group-wired") === "1") return;
          cb.setAttribute("data-amp-group-wired", "1");
          cb.addEventListener("change", () => {
            const isChecked = cb.checked;
            checkboxes.forEach((other) => {
              if (other !== cb) other.checked = isChecked;
            });
          });
        });
      });
    });
  } catch (e) {
    /* consolidation must never block filtering */
  }
}

if (typeof document !== "undefined") {
(() => {
  // Helper function for title case with special character handling
  // Preserves all-caps words (ABB, GE, EATON, etc.)
  function toTitleCase(str) {
    var s = String(str == null ? "" : str).trim();
    if (s.length > 1 && s === s.toUpperCase() && /\s/.test(s)) {
      s = s.toLowerCase();
    }
    return s
      .split(' ')
      .map(word => {
        // Preserve words that are already all uppercase (ABB, GE, etc.)
        if (word === word.toUpperCase() && word.length > 1) {
          return word;
        }
        const lowerWord = word.toLowerCase();
        // Handle words with / in them
        if (lowerWord.includes('/')) {
          return lowerWord.split('/').map(part => {
            if (part === part.toUpperCase() && part.length > 1) return part;
            if (part.includes('-')) {
              return part.split('-').map(p =>
                p.charAt(0).toUpperCase() + p.slice(1)
              ).join('-');
            }
            return part.charAt(0).toUpperCase() + part.slice(1);
          }).join('/');
        }
        // Handle words with - in them
        if (lowerWord.includes('-')) {
          return lowerWord.split('-').map(part =>
            part.charAt(0).toUpperCase() + part.slice(1)
          ).join('-');
        }
        return lowerWord.charAt(0).toUpperCase() + lowerWord.slice(1);
      })
      .join(' ');
  }

  // Format filter text based on filter type
  function formatFilterText(container) {
    container.querySelectorAll('.jsFilterUpdate').forEach((section) => {
      if (insideEngineRail(section)) return;
      const filterId = section.dataset.filterId;
      const titleCaseFilters = ['brand', 'brand_canonical', 'mounting-style', 'trip-technology', 'product_type'];
      section.querySelectorAll('.filter-section-list .text').forEach((el) => {
        var text = el.textContent || "";
        if (filterId === "series") {
          el.textContent = /\s/.test(text) ? toTitleCase(text) : text.toUpperCase();
        } else if (titleCaseFilters.includes(filterId)) {
          el.textContent = toTitleCase(text);
        } else if (filterId === "amperage") {
          // Amperage labels are normalized later. Do not shout them.
        } else {
          el.textContent = text.toUpperCase();
        }
      });
    });
    // Prevent background scroll when scrolling filter list on mobile
document.querySelectorAll('.filter-section-list').forEach(list => {
  list.addEventListener('touchstart', function(e) {
    this.startY = e.touches[0].clientY;
  }, { passive: true });
  
  list.addEventListener('touchmove', function(e) {
    const scrollTop = this.scrollTop;
    const scrollHeight = this.scrollHeight;
    const height = this.clientHeight;
    const deltaY = this.startY - e.touches[0].clientY;
    
    // At top and scrolling up, or at bottom and scrolling down
    if ((scrollTop === 0 && deltaY < 0) || 
        (scrollTop + height >= scrollHeight && deltaY > 0)) {
      e.preventDefault();
    }
  }, { passive: false });
});
  }

  // Enhance active filter labels (e.g. "3" → "3 Pole")
  const paramLabelMap = {
    'poles': ' Pole',
    'phase': ' Phase'
  };
  function formatActiveFilterLabels(container) {
    container.querySelectorAll('.jsFilterRemove').forEach((link) => {
      if (insideEngineRail(link)) return;
      const param = (link.dataset.param || '').toLowerCase();
      const valueEl = link.querySelector('.jsValue');
      // Find the visible display span (not .jsValue which is hidden, not .icon)
      const displayEl = link.querySelector('.jsDisplayLabel') ||
        [...link.querySelectorAll('span')].find(s => !s.classList.contains('jsValue') && !s.classList.contains('icon'));
      if (!valueEl || !displayEl) return;
      const rawValue = valueEl.textContent.trim();
      // Check if already enhanced
      if (displayEl.textContent.trim() !== rawValue) return;
      // Check param name for matching suffix
      for (const [key, suffix] of Object.entries(paramLabelMap)) {
        if (param.includes(key)) {
          displayEl.textContent = rawValue + suffix;
          break;
        }
      }
    });
  }

  // Hide filter options with count of 0, hide entire section if all are 0
  function hideZeroCountFilters(container) {
    container.querySelectorAll('.jsFilterUpdate').forEach((section) => {
      let visibleCount = 0;

      const accordion = section.closest('accordion-component');
      const listItems = section.querySelectorAll('li');
      // Price-range and toolbar update regions have no option rows. They are
      // valid controls, not empty facet groups, so zero-count hiding skips them.
      if (!listItems.length) return;

      listItems.forEach((li) => {
        if (li.getAttribute('data-amp-dup') === '1' || li.getAttribute('data-brand-dup') === '1') return;
        const count = li.querySelector('[data-count]');
        if (count && count.dataset.count === '0') {
          li.classList.add('filter-hidden');
          li.classList.remove('none');
        } else {
          li.classList.remove('filter-hidden');
          li.classList.remove('none');
          visibleCount++;
        }
      });

      // Hide the entire filter block (header + search + list) if no options
      if (accordion) {
        accordion.style.display = visibleCount === 0 ? 'none' : '';
      }

      // Hide search box if fewer than 10 visible values
      const searchBox = section.querySelector('.filter-search');
      if (searchBox) {
        searchBox.style.display = visibleCount < 10 ? 'none' : '';
      }

      const showMoreBtn = section.querySelector('.jsFilterShowMore');
      if (showMoreBtn) {
        showMoreBtn.style.display = 'none';
      }
    });
  }

  /* -------------------------------------------------------------------------
     Analytics helpers (GA4). Emit only -- these never touch the DOM and never
     change filter behaviour. gtag can be removed by consent tooling at any
     time, so every call is guarded and wrapped: analytics must never be able
     to throw inside the filter path.
     ------------------------------------------------------------------------- */
  const GA_VALUE_MAX = 100; // GA4 caps a parameter value at 100 characters.
  function gaText(value) {
    return String(value == null ? "" : value).replace(/\s+/g, " ").trim().slice(0, GA_VALUE_MAX);
  }
  function gaEmit(name, params) {
    try {
      if (window.SBAnalytics) {
        if (!window.SBAnalytics.allowed()) return;
        if (name === 'filter_apply') window.SBAnalytics.emit('sb_filter_apply', {
          interaction_surface: params.filter_surface,
          filter_group: params.filter_group,
          filter_action: params.filter_action,
          result_count: params.filter_results
        });
        if (name === 'filter_clear') window.SBAnalytics.emit('sb_filter_control', {
          interaction_surface: 'native_filters', interaction_action: 'clear'
        });
      }
      if (typeof window.gtag !== "function") return;
      window.gtag("event", name, params);
    } catch (e) {
      /* swallowed on purpose */
    }
  }

  var { debounceTime, addEvent } = theme;
  customElements.define("filter-component", class extends HTMLElement {
    constructor() {
      super();
      this.container = this.closest("[data-section-id]");
      this.cache = [];
      this.andLogic = JSON.parse(this.dataset.andLogic || "false");
      this.filterType = this.dataset.type || "attribute";
      this.form = null;
      this.inputClass = null;
      this.ownsPopupLock = false;
      this.trackedFilterChange = null;
      this.renderToken = 0;
      this.announcementFrame = null;
      this.eventsBound = false;
      this.popStateBound = false;
      this.initialStateCached = false;
      this.onPopState = this.handlePopState.bind(this);
    }
    connectedCallback() {
      const formInput = this.querySelector("input[form]");
      this.form = this.querySelector(":scope > form") ||
        (formInput ? document.getElementById(formInput.getAttribute("form")) : this.querySelector("form"));
      if (!this.form) return;
      this.inputClass = `input[form="${this.form?.id}"]`;
      this.ensureResultsStatus();
      this.suppressTransientResultAnnouncements();
      this.ensurePriceInputLabels();
      if (!this.eventsBound) {
        this.addEvents();
        this.eventsBound = true;
      }
      this.setupDrawerAccessibility();
      if (!this.popStateBound) {
        window.addEventListener("popstate", this.onPopState);
        this.popStateBound = true;
      }
      this.cacheInitialState();
    }
    disconnectedCallback() {
      this.renderToken += 1;
      this.cancelAnnouncement();
      document.body.classList.remove("filter-toggle");
      this.releasePopupLock();
      if (this.popStateBound) {
        window.removeEventListener("popstate", this.onPopState);
        this.popStateBound = false;
      }
      if (this.onDrawerClick) {
        this.removeEventListener("click", this.onDrawerClick);
        document.removeEventListener("keydown", this.onDrawerKeydown);
        window.removeEventListener("resize", this.onDrawerResize);
      }
    }
    ensureResultsStatus() {
      let status = [...this.children].find((child) => child.classList?.contains("filter-results-status"));
      if (status) return status;

      status = document.createElement("span");
      status.className = "filter-results-status";
      status.setAttribute("role", "status");
      status.setAttribute("aria-live", "polite");
      status.setAttribute("aria-atomic", "true");
      this.appendChild(status);
      return status;
    }
    cancelAnnouncement() {
      if (this.announcementFrame === null) return;
      if (typeof window.cancelAnimationFrame === "function") {
        window.cancelAnimationFrame(this.announcementFrame);
      } else {
        window.clearTimeout(this.announcementFrame);
      }
      this.announcementFrame = null;
    }
    suppressTransientResultAnnouncements(scope = this) {
      scope.querySelectorAll(".jsFilterResultCount").forEach((count) => {
        count.removeAttribute("aria-live");
        count.removeAttribute("aria-atomic");
        if (count.getAttribute("role") === "status") count.removeAttribute("role");
      });
    }
    ensurePriceInputLabels() {
      const strings = window.theme?.strings || {};
      const labelInputs = [
        [".price-min input", strings.filterMinimumPrice],
        [".price-max input", strings.filterMaximumPrice]
      ];

      labelInputs.forEach(([selector, label]) => {
        if (!label) return;
        this.querySelectorAll(selector).forEach((input) => {
          if (input.hasAttribute("aria-label") || input.hasAttribute("aria-labelledby")) return;
          if (input.labels && input.labels.length) return;
          input.setAttribute("aria-label", label);
        });
      });
    }
    cacheInitialState() {
      if (this.initialStateCached) return;
      const DOM = document.createElement("div");
      DOM.appendChild(this.cloneNode(true));
      // The rendered page belongs only to the current URL. The form can omit
      // page, default-sort, or other location state, so treating its serialized
      // value as an alias can return page-two results for a page-one URL.
      this.cache.push({ query: this.queryFromLocation(), DOM, requestToken: 0 });
      this.initialStateCached = true;
    }
    isElementVisible(element) {
      if (!(element instanceof HTMLElement) || !element.isConnected) return false;
      if (element.closest("[hidden], [aria-hidden='true'], .filter-hidden")) return false;
      const style = window.getComputedStyle(element);
      if (style.display === "none" || style.visibility === "hidden") return false;
      return element.getClientRects().length > 0;
    }
    isRestorableControl(element) {
      if (!this.isElementVisible(element)) return false;
      if (element.matches(":disabled, [aria-disabled='true'], [tabindex='-1'], input[type='hidden']")) return false;
      return typeof element.focus === "function";
    }
    filterGroupId(element) {
      const wrapper = element.closest?.("[data-filter-id]") ||
        element.closest?.(".filter-block")?.querySelector("[data-filter-id]");
      if (wrapper?.dataset.filterId) return wrapper.dataset.filterId;
      if (element.closest?.(".sort-section")) return "__sort";

      const chip = element.closest?.(".jsFilterRemove");
      const paramName = chip?.dataset.param;
      const value = chip?.querySelector(".jsValue")?.textContent?.trim();
      if (chip?.dataset.facetKey) return chip.dataset.facetKey;
      if (!paramName) return "";
      const matchingInput = [...this.querySelectorAll("input")].find((input) => {
        return input.name === paramName && (!value || input.value === value);
      });
      const inputWrapper = matchingInput?.closest("[data-filter-id]") ||
        matchingInput?.closest(".filter-block")?.querySelector("[data-filter-id]");
      return inputWrapper?.dataset.filterId || "";
    }
    describeFocusControl(element) {
      if (!(element instanceof Element) || !this.contains(element)) return null;
      const control = element.matches("input, button, a[href], summary, select, textarea, [tabindex]")
        ? element
        : element.closest("input, button, a[href], summary, select, textarea, [tabindex]");
      if (!control || !this.contains(control)) return null;

      let kind = "control";
      if (control.matches("input, select, textarea")) kind = "input";
      if (control.matches(".jsFilterRemove")) kind = "chip";
      if (control.matches(".jsFilterReset")) kind = "reset";
      if (control.matches("price-range button[type='submit']")) kind = "price-apply";
      if (control.matches(".link-overlay, a[data-facet-key]")) kind = "facet-link";
      if (control.matches("summary")) kind = "summary";

      return {
        kind,
        tag: control.tagName,
        id: control.id || "",
        name: control.getAttribute("name") || "",
        type: control.getAttribute("type") || "",
        value: control.value ?? control.getAttribute("value") ?? "",
        href: control.getAttribute("href") || "",
        param: control.dataset.param || "",
        facetKey: control.dataset.facetKey || "",
        facetValue: control.dataset.facetValue || "",
        chipValue: control.querySelector?.(".jsValue")?.textContent?.trim() || "",
        text: control.textContent?.replace(/\s+/g, " ").trim() || "",
        groupId: this.filterGroupId(control)
      };
    }
    captureFocusTarget() {
      return this.describeFocusControl(document.activeElement);
    }
    matchesFocusTarget(element, target) {
      const candidate = this.describeFocusControl(element);
      if (!candidate || !target || candidate.kind !== target.kind) return false;
      if (target.groupId && candidate.groupId !== target.groupId) return false;

      if (target.kind === "input") {
        return (!target.id || candidate.id === target.id) &&
          candidate.name === target.name &&
          candidate.type === target.type &&
          String(candidate.value) === String(target.value);
      }
      if (target.kind === "chip") {
        return candidate.param === target.param &&
          candidate.facetKey === target.facetKey &&
          candidate.chipValue === target.chipValue;
      }
      if (target.kind === "reset") return true;
      if (target.kind === "price-apply" || target.kind === "summary") {
        return candidate.groupId === target.groupId;
      }
      if (target.kind === "facet-link") {
        return candidate.href === target.href &&
          candidate.facetKey === target.facetKey &&
          candidate.facetValue === target.facetValue;
      }
      return candidate.tag === target.tag &&
        (!target.id || candidate.id === target.id) &&
        candidate.name === target.name &&
        candidate.href === target.href &&
        candidate.text === target.text;
    }
    shouldRestoreFocus(target) {
      if (!target) return false;
      const active = document.activeElement;
      return !active || active === document.body || active === document.documentElement ||
        this.matchesFocusTarget(active, target);
    }
    focusFallbackForGroup(target) {
      if (!target?.groupId) return null;
      if (target.groupId === "__sort") {
        return [...this.querySelectorAll(".sort-section summary")].find((summary) => this.isRestorableControl(summary)) || null;
      }

      const wrappers = [...this.querySelectorAll("[data-filter-id]")].filter((wrapper) => {
        return wrapper.dataset.filterId === target.groupId;
      });
      for (const wrapper of wrappers) {
        const summary = wrapper.closest(".filter-block")?.querySelector("summary");
        if (summary && this.isRestorableControl(summary)) return summary;
      }
      return null;
    }
    restoreFocusTarget(target) {
      if (!target) return false;
      const selector = "input, button, a[href], summary, select, textarea, [tabindex]";
      const exact = [...this.querySelectorAll(selector)].find((control) => {
        return this.matchesFocusTarget(control, target) && this.isRestorableControl(control);
      });
      const candidates = [exact, this.focusFallbackForGroup(target)].filter(Boolean);
      for (const candidate of candidates) {
        try {
          candidate.focus({ preventScroll: true });
          if (document.activeElement === candidate) return true;
        } catch (e) {
          /* A removed or disabled control falls through to the group summary. */
        }
      }
      return false;
    }
    visibleResultCountText() {
      const counts = this.querySelectorAll(".plp-toolbar-count, .sfs-result-count, .jsFilterResultCount");
      for (const count of counts) {
        const text = count.textContent?.replace(/\s+/g, " ").trim();
        if (text && this.isElementVisible(count)) return text;
      }
      return "";
    }
    announceResultsUpdated(requestToken) {
      const status = this.ensureResultsStatus();
      const prefix = window.theme?.strings?.filterResultsUpdated || "";
      const count = this.visibleResultCountText();
      const message = `${prefix}${count ? ` ${count}` : ""}`.trim();
      this.cancelAnnouncement();
      status.textContent = "";

      const announce = () => {
        this.announcementFrame = null;
        if (!this.isConnected || requestToken !== this.renderToken) return;
        status.textContent = message;
      };
      this.announcementFrame = typeof window.requestAnimationFrame === "function"
        ? window.requestAnimationFrame(announce)
        : window.setTimeout(announce, 0);
    }
    setupDrawerAccessibility() {
      this.refreshDrawerElements();
      if (!this.drawer || !this.drawerTrigger) return;

      this.onDrawerClick = this.handleDrawerClick.bind(this);
      this.onDrawerKeydown = this.handleDrawerKeydown.bind(this);
      this.onDrawerResize = this.syncDrawerAccessibility.bind(this, false);
      this.addEventListener("click", this.onDrawerClick);
      document.addEventListener("keydown", this.onDrawerKeydown);
      window.addEventListener("resize", this.onDrawerResize);
      this.syncDrawerAccessibility(false);
    }
    refreshDrawerElements() {
      this.drawer = this.querySelector(".sidebar-section-content");
      const currentTrigger = this.querySelector(".filter-btn .btn-filter");
      this.drawerClose = this.querySelector(".sidebar-section-content .btn-popup-close");
      if (!this.drawer || !currentTrigger) return;

      if (!this.drawer.id) {
        this.drawer.id = `FilterDrawer${this.dataset.sectionId || ""}`;
      }
      this.drawerTrigger = currentTrigger;
      this.drawerTrigger.setAttribute("aria-controls", this.drawer.id);
      this.drawerTrigger.setAttribute(
        "aria-expanded",
        document.body.classList.contains("filter-toggle") ? "true" : "false"
      );
    }
    isMobileDrawer() {
      return window.matchMedia("(max-width: 991.98px)").matches;
    }
    isDrawerOpen() {
      return this.isMobileDrawer() && document.body.classList.contains("filter-toggle");
    }
    handleDrawerClick(event) {
      const openTrigger = event.target.closest(".filter-btn .btn-filter");
      if (openTrigger && this.contains(openTrigger)) {
        this.drawerTrigger = openTrigger;
        // Run after the delegated theme click handler and browser focus default.
        window.setTimeout(() => this.syncDrawerAccessibility(true), 50);
        return;
      }

      const closeTrigger = event.target.closest(".btn-popup-close, .popup-layer, .jsFilterDrawerClose");
      if (closeTrigger && this.contains(closeTrigger)) {
        window.setTimeout(() => this.closeFilterDrawer(true), 0);
      }
    }
    handleDrawerKeydown(event) {
      if (!this.isDrawerOpen()) return;

      if (event.key === "Escape") {
        event.preventDefault();
        this.closeFilterDrawer(true);
        return;
      }
      if (event.key !== "Tab") return;

      const focusable = this.getDrawerFocusable();
      if (!focusable.length) {
        event.preventDefault();
        this.drawerClose?.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const activeElement = document.activeElement;
      if (!this.drawer.contains(activeElement)) {
        event.preventDefault();
        first.focus();
      } else if (event.shiftKey && activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
    getDrawerFocusable() {
      const selector = [
        "a[href]",
        "button:not([disabled])",
        "input:not([disabled]):not([type='hidden'])",
        "select:not([disabled])",
        "textarea:not([disabled])",
        "[tabindex]:not([tabindex='-1'])"
      ].join(",");
      return [...this.drawer.querySelectorAll(selector)].filter((element) => {
        return !element.hasAttribute("hidden") &&
          element.getAttribute("aria-hidden") !== "true" &&
          (element.offsetParent !== null || element === document.activeElement);
      });
    }
    syncDrawerAccessibility(focusDrawer = false) {
      if (!this.isMobileDrawer()) {
        document.body.classList.remove("filter-toggle");
        this.releasePopupLock();
        this.drawer.removeAttribute("role");
        this.drawer.removeAttribute("aria-modal");
        this.drawerTrigger.setAttribute("aria-expanded", "false");
        return;
      }
      if (!this.isDrawerOpen()) {
        this.releasePopupLock();
        this.drawer.removeAttribute("role");
        this.drawer.removeAttribute("aria-modal");
        this.drawerTrigger.setAttribute("aria-expanded", "false");
        return;
      }

      document.body.classList.add("show-popup");
      this.ownsPopupLock = true;
      this.drawer.setAttribute("role", "dialog");
      this.drawer.setAttribute("aria-modal", "true");
      this.drawerTrigger.setAttribute("aria-expanded", "true");
      if (focusDrawer) {
        this.drawerClose?.focus();
      }
    }
    releasePopupLock() {
      if (!this.ownsPopupLock) return;
      document.body.classList.remove("show-popup");
      this.ownsPopupLock = false;
    }
    closeFilterDrawer(restoreFocus = false) {
      document.body.classList.remove("filter-toggle");
      this.releasePopupLock();
      this.drawer.removeAttribute("role");
      this.drawer.removeAttribute("aria-modal");
      this.drawerTrigger.setAttribute("aria-expanded", "false");
      if (restoreFocus) {
        this.drawerTrigger?.focus();
      }
    }
    addEvents() {
      this.addEventListener("change", ({ target }) => {
        let selectedTarget = target;
        if (selectedTarget.name == "sortBy") {
          const sortEl = [...this.querySelectorAll("[name=sort_by]")].find((item) => item.value == selectedTarget.value);
          sortEl.checked = true;
          selectedTarget = sortEl;
        }
        this.onChange(selectedTarget);
      });
      this.form.addEventListener("submit", (e) => {
        e.preventDefault();
        this.submit();
      });
      this.addEventListener("click", (e) => {
        const reset = e.target.closest?.(".jsFilterReset");
        if (!reset || !this.contains(reset)) return;
        if (reset.hasAttribute("data-clear-filter-navigation") && this.isMobileDrawer()) return;
        e.preventDefault();
        this.uncheckInput();
        this.submit();
      });
      this.removeFilter();
      this.filterSearch();
      this.setupFilterTracking();
    }
    /* -----------------------------------------------------------------------
       Filter analytics. Purely observational: it listens, it never calls
       preventDefault, never mutates the DOM, never issues a request. The
       listeners are registered in the CAPTURE phase on purpose, because the
       handlers above call submit() synchronously (the cache-hit branch
       re-renders with no await) -- a bubble-phase listener would run after the
       re-render and miss the change that caused it.
       ----------------------------------------------------------------------- */
    setupFilterTracking() {
      try {
        this.addEventListener("change", (event) => this.recordFilterChange(event.target), true);
        this.addEventListener("click", (event) => this.recordFilterClick(event), true);
      } catch (e) {
        /* analytics must never break filtering */
      }
    }
    recordFilterChange(input) {
      try {
        this.trackedFilterChange = null;
        // Only inputs that actually trigger a re-render. The price-range number
        // fields fire change but carry no auto-submit, so nothing would follow.
        if (!input || !input.name || !input.hasAttribute("auto-submit")) return;
        // sort_by / sortBy auto-submit too; they are not facets.
        if (input.name.indexOf("filter.") !== 0) return;
        this.trackedFilterChange = {
          journeyIntent: window.SBJourney && window.SBJourney.filterStart(input, input.checked ? "add" : "remove"),
          group: this.filterGroupLabel(input, input.name),
          value: this.filterValueLabel(input),
          action: input.checked ? "add" : "remove",
          surface: this.filterSurface(input)
        };
      } catch (e) {
        this.trackedFilterChange = null;
      }
    }
    recordFilterClick(event) {
      try {
        const target = event.target;
        if (!target || !target.closest) return;

        // Clear all. Delegated rather than bound to the button, because render()
        // replaces the .filter-active block and with it the original element.
        const reset = target.closest(".jsFilterReset");
        if (reset && this.contains(reset)) {
          this.trackedFilterChange = null;
          gaEmit("filter_clear", {
            filter_collection: this.filterCollection(),
            filter_active_count: this.activeFilterCount(this) // measured BEFORE clearing
          });
          return;
        }

        // The "x" on an applied-filter chip is the other way a facet comes off.
        const chip = target.closest(".jsFilterRemove");
        if (!chip || !this.contains(chip)) return;
        const paramName = chip.dataset.param || "";
        const rawValue = (chip.querySelector(".jsValue")?.textContent || "").trim();
        const input = this.findFilterInput(paramName, rawValue);
        this.trackedFilterChange = {
          journeyIntent: (!input || input.checked) && window.SBJourney && window.SBJourney.filterStart(chip, "remove"),
          group: this.filterGroupLabel(input, paramName),
          value: input ? this.filterValueLabel(input) : gaText(rawValue),
          action: "remove",
          surface: this.filterSurface(chip)
        };
      } catch (e) {
        this.trackedFilterChange = null;
      }
    }
    takeTrackedFilterChange() {
      try {
        const tracked = this.trackedFilterChange || null;
        this.trackedFilterChange = null;
        return tracked;
      } catch (e) {
        return null;
      }
    }
    trackFilterApply(tracked, result, query) {
      if (!tracked) return; // sort changes and price submits are not facet applies
      try {
        if (window.SBJourney) window.SBJourney.filterComplete(tracked.journeyIntent, result);
        const collectionHandle = this.filterCollection();
        const results = this.filterResultCount(result);
        const params = {
          filter_group: tracked.group,
          filter_value: tracked.value,
          filter_action: tracked.action,
          filter_surface: tracked.surface,
          filter_collection: collectionHandle,
          filter_active_count: this.activeFilterCount(result)
        };
        if (typeof results === "number") params.filter_results = results;
        gaEmit("filter_apply", params);

        // The dead ends: which facet combinations strand a shopper on nothing.
        if (results === 0) {
          gaEmit("filter_zero_results", {
            filter_collection: collectionHandle,
            filter_combination: this.filterCombination(query)
          });
        }
      } catch (e) {
        /* analytics must never break filtering */
      }
    }
    /* The applied facet combination, compacted so it survives GA4's 100
       character ceiling. Measured against the real form: the raw form query
       burns roughly 20 characters per facet on Shopify's "filter.p.m.breakers."
       prefix, plus sort_by and the untouched price bounds, so the truncation
       was cutting off the very facet that produced the dead end. This keeps
       only real facets, strips the namespace, drops price bounds the shopper
       never moved (Shopify does not count those as active either), and sorts
       so the same combination always aggregates as one row in GA4. */
    filterCombination(query) {
      try {
        const source = query != null ? query : this.getQueryString;
        const params = new URLSearchParams(source);
        const pairs = [];
        params.forEach((value, key) => {
          if (key.indexOf("filter.") !== 0) return; // sort_by, q, type, view
          if (!String(value).length) return;
          if (key.indexOf("filter.v.price.") === 0 && this.isDefaultPriceBound(key, value)) return;
          const short = key
            .replace(/^filter\.p\.m\.[^.]+\./, "")
            .replace(/^filter\.[pv]\./, "")
            .replace(/^filter\./, "");
          pairs.push(`${short}=${value}`);
        });
        pairs.sort();
        if (!pairs.length) return gaText(source);
        return gaText(pairs.join("&"));
      } catch (e) {
        return gaText(query);
      }
    }
    isDefaultPriceBound(key, value) {
      try {
        const input = this.querySelector(`input[form="${this.form.id}"][name="${key}"]`);
        if (!input) return false;
        const bound = input.getAttribute(key.slice(-4) === ".lte" ? "max" : "min");
        return bound != null && String(bound) === String(value);
      } catch (e) {
        return false;
      }
    }
    /* Post-filter product count, read out of the HTML the component already
       fetched -- no second request. Search renders an exact integer in
       data-search-results-total. Collection pages only render the localised
       "N results" string, so the digits are stripped out of it. */
    filterResultCount(result) {
      try {
        if (!result) return null;
        const exact = result.querySelector("[data-search-results-total]");
        if (exact) {
          const parsed = parseInt(exact.getAttribute("data-search-results-total"), 10);
          if (!isNaN(parsed)) return parsed;
        }
        const el = result.querySelector(".jsFilterResultCount") ||
          result.querySelector(".collection-count, .search-count");
        if (!el) return null;
        const digits = (el.textContent || "").replace(/[^0-9]/g, "");
        if (!digits.length) return null;
        return parseInt(digits, 10);
      } catch (e) {
        return null;
      }
    }
    /* Exactly one .jsFilterRemove chip is rendered per active filter value. */
    activeFilterCount(scope) {
      try {
        return (scope || this).querySelectorAll(".jsFilterRemove").length;
      } catch (e) {
        return 0;
      }
    }
    /* sidebar | top_strip | drawer. The mobile drawer is the filter-toggle
       body-class path, which isDrawerOpen() already models for the aria state,
       so this cannot drift away from the real drawer state. */
    filterSurface(el) {
      try {
        if (window.SBAnalytics) return window.SBAnalytics.surface(el);
        if (!el || !el.closest) return "";
        if (el.closest(".slider-filter")) return "top_strip";
        if (el.closest(".sidebar-section-content")) {
          return this.isDrawerOpen() ? "drawer" : "sidebar";
        }
        return "other";
      } catch (e) {
        return "";
      }
    }
    /* Visible facet heading, e.g. "Poles". Falls back to the wrapper's
       data-filter-id, then to the Shopify param name, because the top-strip
       series slider renders no heading of its own. */
    filterGroupLabel(input, paramName) {
      try {
        const block = input && input.closest ? input.closest(".filter-block") : null;
        const heading = block && block.querySelector("summary .label");
        if (heading && heading.textContent.trim()) return gaText(heading.textContent);

        const wrapper = input && input.closest ? input.closest(".jsFilterUpdate") : null;
        if (wrapper && wrapper.dataset.filterId) return gaText(this.humanizeKey(wrapper.dataset.filterId));

        return gaText(this.humanizeKey(String(paramName || "").split(".").pop()));
      } catch (e) {
        return "";
      }
    }
    humanizeKey(text) {
      return String(text || "").replace(/[_-]+/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
    }
    /* The shopper-visible value ("QOB", "3", "20"), not the raw Shopify value,
       which is an opaque GID for grouped vendor filters. */
    filterValueLabel(input) {
      try {
        if (!input) return "";
        const item = input.closest("li");
        const text = item && item.querySelector(".text");
        if (text && text.textContent.trim()) return gaText(text.textContent);
        return gaText(input.value);
      } catch (e) {
        return "";
      }
    }
    findFilterInput(name, value) {
      try {
        const inputs = this.querySelectorAll(`input[form="${this.form.id}"]`);
        for (const input of inputs) {
          if (name && input.name !== name) continue;
          if (input.value !== value) continue;
          return input;
        }
      } catch (e) {
        /* fall through */
      }
      return null;
    }
    /* Collection handle the shopper is on. Taken from the form action, which
       stays put while history.pushState rewrites the visible URL. */
    filterCollection() {
      try {
        const path = new URL(this.form.action, window.location.href).pathname;
        const match = path.match(/\/collections\/([^/?#]+)/);
        if (match) return gaText(decodeURIComponent(match[1]));
        if (/\/search/.test(path)) return "search";
        return gaText(path.replace(/^\/+|\/+$/g, "") || "index");
      } catch (e) {
        return "";
      }
    }
    onChange(target) {
      const input = target;
      !this.andLogic && this.uncheckInput(input);
      document.querySelectorAll(`.filter-input[id='${input.id}']`).forEach((cb) => {
        cb.checked = input.checked;
      });
      if (target.hasAttribute("auto-submit"))
        this.submit();
    }
    uncheckInput(input = null) {
      let inputList;
      if (input) {
        inputList = this.querySelectorAll(`input[name="${input.name}"][form="${this.form.id}"]:not([id="${input.id}"])`);
      } else {
        inputList = this.querySelectorAll(`input[form="${this.form.id}"]`);
      }
      inputList.forEach((i) => {
        i.removeAttribute("checked");
        i.checked = false;
      });
    }
    get getQueryString() {
      const formData = new FormData(this.form);
      const query = new URLSearchParams(formData);
      if (this.filterType == "attribute")
        return query.toString();
      const queryString = query.toString();
      const arrayFilter = [];
      let sort = "";
      queryString.split("&").map((i) => {
        !i.includes("sort_by=") ? arrayFilter.push(i.split("=")[1]) : sort = i;
      });
      return arrayFilter.join("+") + (sort.length ? `?${sort}` : "");
    }
    buildHistoryUrl(query) {
      const base = new URL(this.form.action, window.location.href);
      if (this.filterType === "attribute") {
        base.search = query ? `?${query}` : "";
        base.hash = "";
        return `${base.pathname}${base.search}`;
      }

      const queryParts = String(query || "").split("?");
      const tags = queryParts.shift() || "";
      const sort = queryParts.join("?");
      const path = base.pathname.replace(/\/$/, "") + (tags ? `/${tags}` : "");
      return `${path}${sort ? `?${sort}` : ""}`;
    }
    buildSectionUrl(query) {
      const url = new URL(this.buildHistoryUrl(query), window.location.origin);
      url.searchParams.set("section_id", this.dataset.sectionId);
      return url.toString();
    }
    queryFromLocation() {
      if (this.filterType === "attribute") {
        const params = new URLSearchParams(window.location.search);
        params.delete("section_id");
        return params.toString();
      }

      const base = new URL(this.form.action, window.location.href);
      const basePath = base.pathname.replace(/\/$/, "");
      const currentPath = window.location.pathname;
      const tags = currentPath.indexOf(`${basePath}/`) === 0
        ? currentPath.slice(basePath.length + 1)
        : "";
      const sort = window.location.search.replace(/^\?/, "");
      return `${tags}${sort ? `?${sort}` : ""}`;
    }
    isValidResult(DOM) {
      if (!DOM || typeof DOM.querySelector !== "function") return false;
      return Boolean(
        DOM.querySelector("#" + this.dataset.product) &&
        DOM.querySelector(".jsFilterUpdate")
      );
    }
    cacheResult(query, DOM, requestToken) {
      const cached = this.cache.find((item) => item.query === query);
      if (cached) {
        if ((cached.requestToken ?? -1) >= requestToken) return false;
        cached.DOM = DOM;
        cached.requestToken = requestToken;
      } else {
        this.cache.push({ query, DOM, requestToken });
      }
      return true;
    }
    requestResults(query, options) {
      const cachedIndex = this.cache.findIndex((item) => item.query === query);
      const cached = cachedIndex === -1 ? null : this.cache[cachedIndex];
      if (cached && this.isValidResult(cached.DOM)) {
        return Promise.resolve(this.render(cached.DOM, query, options));
      }
      if (cachedIndex !== -1) this.cache.splice(cachedIndex, 1);

      return fetch(this.buildSectionUrl(query))
        .then((response) => {
          if (!response.ok) throw new Error("Filter request failed");
          return response.text();
        })
        .then((html) => {
          const DOM = document.createElement("div");
          DOM.innerHTML = html;
          if (!this.isValidResult(DOM)) return false;
          this.cacheResult(query, DOM, options.requestToken);
          if (options.requestToken !== this.renderToken) return false;
          return this.render(DOM, query, options);
        })
        .catch(() => false);
    }
    handlePopState(event) {
      const stateQuery = event?.state && typeof event.state.searchParams === "string"
        ? event.state.searchParams
        : null;
      const query = stateQuery === null ? this.queryFromLocation() : stateQuery;
      const requestToken = ++this.renderToken;
      const focusTarget = this.captureFocusTarget();
      this.requestResults(query, {
        requestToken,
        focusTarget,
        updateHistory: false,
        emitAnalytics: false,
        trackedChange: null,
        announce: true
      });
    }
    submit() {
      const query = this.getQueryString;
      // Claimed here, not read later, so two fast toggles cannot cross-report:
      // each submit carries its own change through to its own response.
      const trackedChange = this.takeTrackedFilterChange();
      const requestToken = ++this.renderToken;
      const focusTarget = this.captureFocusTarget();
      return this.requestResults(query, {
        requestToken,
        focusTarget,
        updateHistory: true,
        emitAnalytics: true,
        trackedChange,
        announce: true
      }).then((rendered) => {
        if (rendered === false && window.SBJourney && trackedChange) {
          window.SBJourney.filterComplete(trackedChange.journeyIntent, null);
        }
        return rendered;
      });
    }
    render(result, searchParams = null, options = {}) {
      const requestToken = options.requestToken ?? this.renderToken;
      if (requestToken !== this.renderToken) return false;
      const focusTarget = options.focusTarget || null;
      const shouldRestore = this.shouldRestoreFocus(focusTarget);
      const currentProduct = this.querySelector("#" + this.dataset.product);
      const nextProduct = result.querySelector("#" + this.dataset.product);
      if (!currentProduct || !nextProduct) return false;
      this.suppressTransientResultAnnouncements(result);

      this.querySelectorAll(this.inputClass).forEach((input) => {
        if (!input.id)
          return;
        input.checked = result.querySelector(`#${input.id}`)?.checked || false;
      });
      currentProduct.innerHTML = nextProduct.innerHTML;
      this.querySelectorAll(".jsFilterUpdate")?.forEach((item) => {
        let newItem;
        if (item.dataset.filterId) {
          newItem = result.querySelector(`[data-filter-id="${item.dataset.filterId}"]`);
        } else {
          newItem = result.querySelector(`[class="${item.className}"]`);
        }
        if (!newItem)
          return;
        item.innerHTML = newItem.innerHTML;
      });

      if (typeof window.__sbNormalizeProxySearchHeading === "function") {
        window.__sbNormalizeProxySearchHeading();
      }

      const currentResultCount = this.querySelector(".jsFilterResultCount");
      const nextResultCount = result.querySelector(".jsFilterResultCount");
      if (currentResultCount && nextResultCount) {
        currentResultCount.textContent = nextResultCount.textContent;
      }

      // Apply formatting
      hideZeroCountFilters(this);
      formatFilterText(this);
      consolidateAmperageFilters(this);
      consolidateBrandFilters(this);
      formatActiveFilterLabels(this);

      this.refreshDrawerElements();
      this.syncDrawerAccessibility(false);
      this.ensurePriceInputLabels();
      this.suppressTransientResultAnnouncements();
      this.removeFilter();
      this.filterSearch();
      if (requestToken !== this.renderToken) return false;

      if (options.updateHistory && searchParams !== null) {
        try {
          history.pushState({ searchParams }, "", this.buildHistoryUrl(searchParams));
        } catch (e) {
          /* Results still work if a browser refuses the same-origin URL update. */
        }
      }
      if (shouldRestore) this.restoreFocusTarget(focusTarget);
      if (options.updateHistory) {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      }
      if (options.emitAnalytics) {
        this.trackFilterApply(options.trackedChange, result, searchParams);
      }
      if (options.announce !== false) this.announceResultsUpdated(requestToken);
      return true;
    }
    removeFilter() {
      this.querySelectorAll(".jsFilterRemove")?.forEach((item) => {
        item.addEventListener("click", (event) => {
          event.preventDefault();
          const value = item.querySelector(".jsValue").textContent;
          const paramName = item.dataset.param;
          this.querySelectorAll(`input[form="${this.form.id}"]`).forEach((item2) => {
            if (paramName && item2.name !== paramName) return;
            if (item2.value != value) return;
            item2.checked = false;
          });
          this.submit();
        });
      });
    }
    filterSearch() {
      this.querySelectorAll(".jsFilterSearch")?.forEach((item) => {
        const parentEl = item.closest(".filter-block");
        item.addEventListener("click", (e) => {
          e.preventDefault();
          const value = item.previousElementSibling.value;
          searchFilterValue(parentEl, value);
        });
        item.previousElementSibling.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.keyCode === 13) {
            e.preventDefault();
            const value = e.target.value;
            searchFilterValue(parentEl, value);
            return;
          }
        });
        item.previousElementSibling.addEventListener("keyup", (e) => {
          if (e.key === "Enter" || e.keyCode === 13) return;
          (e.keyCode == 8 || !item.previousElementSibling.value.length) && clearField(parentEl);
          const value = item.previousElementSibling.value;
          searchFilterValue(parentEl, value);
        });
      });
      const clearField = (el) => {
        el.querySelectorAll("li.matched")?.forEach((item) => item.classList.remove("matched"));
      };
      const searchFilterValue = (container, value) => {
        const filterListItem = container.querySelectorAll("[name*=filter]");
        if (value.length) {
          container.classList.add("searching");
          const normalizedSearch = value.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
          filterListItem.forEach((item) => {
            const normalizedValue = item.value.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
            const parentEl = item.closest("li");
            // Don't match items that are hidden (0-count)
            if (parentEl.classList.contains('filter-hidden')) {
              parentEl.classList.remove("matched");
              return;
            }
            parentEl.classList.toggle("matched", normalizedValue.includes(normalizedSearch));
          });
        } else {
          container.classList.remove("searching");
          container.querySelectorAll(".matched")?.forEach((item) => item.classList.remove("matched"));
        }
        container.querySelector(".jsFilterShowMore")?.classList.toggle("none", value.length);
      };
    }
  });

  // Show More button handler
  document.querySelectorAll('.jsFilterShowMore').forEach(btn => {
    btn.addEventListener('click', function() {
      const container = this.closest('.filter-block, .filter-section-wrapper');
      const filterList = container.querySelectorAll('.jsFilterToggle.none');
      filterList.forEach((item, index) => {
        if (index < 10) item.classList.remove('none');
      });
      const hiddenFilterCount = container.querySelectorAll('.jsFilterToggle.none').length;
      if (!hiddenFilterCount) this.classList.add('none');
      this.querySelector('.attr-count').setAttribute('data-count', Math.min(10, hiddenFilterCount));
    });
  });

  function formatSearchHeading() {
    try {
      var el =
        document.querySelector(".shopify-section-main-search .search-query-display") ||
        document.querySelector(".shopify-section-main-search h1.section-heading");
      if (!el) return;
      var t = (el.textContent || "").trim();
      if (!t || /\d/.test(t)) return;
      el.textContent = toTitleCase(t);
    } catch (e) {}
  }

  window.__sbFormatFilters = function (root) {
    try {
      var el = root || document;
      hideZeroCountFilters(el);
      formatFilterText(el);
      consolidateAmperageFilters(el);
      consolidateBrandFilters(el);
      formatActiveFilterLabels(el);
      formatSearchHeading();
    } catch (e) {
      /* formatting must never block filtering */
    }
  };

  // Apply formatting on page load
  window.__sbFormatFilters(document);

})();
}

if (typeof module !== "undefined" && module.exports) {
  module.exports = {
    normalizeAmpLabel,
    normalizeBrandLabel,
    consolidateBrandFilters,
    consolidateAmperageFilters,
    insideEngineRail
  };
}
